import Entity from '../entity'

export default class WxUser extends Entity<number>{
    wxUserNo: string  = null;
    avatarUrl: string  = null;
    nickName: string  = null;
    gender: string  = null;
    country: string  = null;
    province: string  = null;
    city: string  = null;
    language: string  = null;
    unionId: string  = null;
    mobile: string  = null;
    userId: string  = null;
    tenantId: number  = null;
    remark: string  = null;
}